module.exports = __webpack_public_path__ + "static/img/db.4d2c2dde.png";